// extracted by mini-css-extract-plugin
export default {"c_video__poster":"style_c_video__poster_dEYKl","playerbutton":"style_playerbutton_vs75z","narrowWindow":"style_narrowWindow_c4lcw"};